<div class="container-fluid tw-relative tw-bg-white tw-overflow-hidden tw-py-24 tw-min-h-[100dvh] tw-flex tw-items-center tw-justify-center">
  <!-- Fondo decorativo inferior derecho -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-no-repeat tw-bg-right-bottom tw-bg-[url('/assets/images/logoOrange.png')] tw-opacity-20 tw-blur-[2px] tw-z-0 tw-pointer-events-none"
    style="background-size: 300px"
  ></div>

  <!-- Contenido principal -->
  <div class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-6 lg:tw-px-12 hover:-tw-translate-y-2 tw-duration-300 tw-transition-all">
    <div class="tw-bg-[rgba(0,0,0,0.8)] tw-rounded-3xl tw-shadow-2xl tw-p-8 md:tw-p-12 tw-max-w-5xl tw-mx-auto tw-text-white">
      <h2 class="tw-text-center tw-font-montserrat tw-font-extrabold tw-text-[#F67011] tw-text-3xl sm:tw-text-4xl md:tw-text-5xl tw-mb-8 md:tw-mb-12 tw-tracking-tighter">
        Nuestros <span class="tw-text-white/90">Valores</span>
      </h2>

      <ul class="tw-list-none tw-space-y-6 md:tw-space-y-8 tw-text-base sm:tw-text-lg md:tw-text-xl tw-leading-relaxed tw-text-justify">
        <li class="tw-flex tw-gap-4">
          <div class="tw-flex tw-flex-col tw-items-center">
            <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#F67011] tw-mt-3"></div>
            <div class="tw-w-px tw-h-full tw-bg-[#F67011]/30"></div>
          </div>
          <div>
            <p class="tw-font-semibold tw-text-[#F67011] tw-mb-1">Honestidad e integridad:</p>
            <p class="tw-text-white/90">Ofrecemos servicios que podemos cumplir con coherencia y transparencia. Son pilares fundamentales en nuestra cultura.</p>
          </div>
        </li>
        
        <li class="tw-flex tw-gap-4">
          <div class="tw-flex tw-flex-col tw-items-center">
            <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#F67011] tw-mt-3"></div>
            <div class="tw-w-px tw-h-full tw-bg-[#F67011]/30"></div>
          </div>
          <div>
            <p class="tw-font-semibold tw-text-[#F67011] tw-mb-1">Responsabilidad y compromiso:</p>
            <p class="tw-text-white/90">Trabajamos con profesionalismo, de forma proactiva y consciente, garantizando excelencia y atención de calidad para nuestros clientes.</p>
          </div>
        </li>
        
        <li class="tw-flex tw-gap-4">
          <div class="tw-flex tw-flex-col tw-items-center">
            <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#F67011] tw-mt-3"></div>
            <div class="tw-w-px tw-h-full tw-bg-[#F67011]/30"></div>
          </div>
          <div>
            <p class="tw-font-semibold tw-text-[#F67011] tw-mb-1">Trabajo en equipo:</p>
            <p class="tw-text-white/90">Fomentamos la colaboración, comunicación y respeto para lograr objetivos comunes y fortalecer nuestras capacidades colectivas.</p>
          </div>
        </li>
        
        <li class="tw-flex tw-gap-4">
          <div class="tw-flex tw-flex-col tw-items-center">
            <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#F67011] tw-mt-3"></div>
            <div class="tw-w-px tw-h-full tw-bg-[#F67011]/30"></div>
          </div>
          <div>
            <p class="tw-font-semibold tw-text-[#F67011] tw-mb-1">Mejora continua e innovación:</p>
            <p class="tw-text-white/90">Buscamos oportunidades de crecimiento y adaptación en un entorno dinámico, manteniéndonos competitivos y visionarios.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
